// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".32db0d1067d6297a3a9ff1f241ae4da8.js";
};